import lazyImport from '../../../Utils/Loading/loadingHelpers'

export const TextField = lazyImport(() => import('@mui/material/TextField'))
